import React, { useState } from "react";
import CommonListHeader from 'components/layout/list/header'
import CommonNavigatorHeader from "components/layout/list/navigation";
import CommonTableContainer from 'components/layout/list/table'
import { useUserListQuery } from "services/user";
import { v4 as uuidv4 } from 'uuid';

const UserMain = () => {

    const tableTitle = [
        { md: 2, value: 'Name' },
        { md: 5, value: 'Username / E-Mail', sort: 'User Id' },
        { md: 2, value: 'Phone' },
        { md: 1, value: 'Organization' },
        { md: 1, value: 'Role' },
        { md: 1, value: 'Joined Since' },
        { md: 1, value: 'Status' },
    ]

    const [criteria, setCriteria] = useState({
        page: 0,
        limit: 10,
        requestId: uuidv4(),
        sort: 'role.keyword',
        order: 'desc',
        searchKeyword: '',
    });

    const [page, setPage] = useState(0)

    const { activeList, activeCount, activeStatus } = useUserListQuery(criteria,
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                activeList: data?.rows || [],
                activeCount: data?.count || 0,
                activeStatus: status,
            })
        }
    );

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: "User Management", description: "List of all Users", link: '/users/create', buttonName: "Create New User" }} />
            <CommonNavigatorHeader value={{
                total: activeCount,
                search: {
                    label: '',
                    placeHolder: ''
                },
                setPage: setPage,
                page: page,
                setCriteria: setCriteria,
                criteria: criteria
            }} />

            <CommonTableContainer
                value={{
                    tableTitle: tableTitle,
                    sort: 'User Id',
                    loadRow: [0, 1, 2, 3, 4, 5],
                    loadColumn: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    activeList: activeList,
                    type: 'user',
                    fulfilled: activeStatus
                }}
            />
        </React.Fragment>
    );
}

export default UserMain;